import Vue from 'vue';
import Vuex from 'vuex';
import { module as devices } from '@/store/modules/devices';
import { module as tollDomain } from '@/store/modules/tollDomain';
import { module as dats } from '@/store/modules/dats';
import { module as datInstances } from '@/store/modules/datInstances';
import { module as permissions } from '@/store/modules/permissions';
import { module as personalisation } from '@/store/modules/personalisation';
import { module as user } from '@/store/modules/user';
import { module as userRoles } from '@/store/modules/userRoles';
import { module as groupManagement } from '@/store/modules/groupManagement';
import { module as history } from '@/store/modules/history';
import { module as metrics } from '@/store/modules/metrics';
import { module as checker } from '@/store/modules/checker';

Vue.use(Vuex);

const store = {
  state: {
    version: '1.0.0'
  },
  modules: {
    devices,
    tollDomain,
    dats,
    datInstances,
    permissions,
    personalisation,
    user,
    userRoles,
    groupManagement,
    history,
    metrics,
    checker
  }
};

export default new Vuex.Store<any>(store);
